import { useCallback, useEffect, useState } from 'react';
import useApiClient from './useApiClient';

export default function useArticleLike(initial: boolean, articleId: string) {
  const [liked, setLiked] = useState(initial);
  const { apiClient } = useApiClient();

  useEffect(() => {
    // articleIdが変化した場合は保存済みフラグの値を初期化する
    setLiked(initial);
  }, [initial, articleId]);

  const likeArticle = useCallback(async () => {
    if (liked) {
      return;
    }
    setLiked(true);
    try {
      const res = await apiClient('/api/article/like', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          articleId,
        }),
      });
      if (res.ok) {
        setLiked(true);
      } else {
        setLiked(false);
        throw new Error();
      }
    } catch {
      setLiked(false);
      throw new Error();
    }
  }, [liked, articleId, apiClient]);

  const unlikeArticle = useCallback(async () => {
    if (!liked) {
      return;
    }
    setLiked(false);
    try {
      const res = await apiClient('/api/article/unlike', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          articleId,
        }),
      });
      if (res.ok) {
        setLiked(false);
      } else {
        setLiked(true);
        throw new Error();
      }
    } catch {
      setLiked(true);
      throw new Error();
    }
  }, [liked, articleId, apiClient]);

  return {
    liked,
    likeArticle,
    unlikeArticle,
  };
}
